import React from 'react';
import { observer } from 'mobx-react-lite';

import { useStores } from 'hooks/useStores';
import { DescriptionStyles, Header, Text } from './DescriptionStyles';

const Description = observer(() => {
  const {
    advertsStore: {
      currentAdvert: { comment },
    },
  } = useStores();
  return (
    comment && (
      <DescriptionStyles>
        <Header>Описание</Header>
        <Text>{comment.replace(/\n{3,}/g, '\n\n')}</Text>
      </DescriptionStyles>
    )
  );
});

export default Description;
